import React from "react";
import "./Footer.scss";
import { Box } from "@mui/material";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box className="footer">
      <Box className="footer-text">Powered by PAiY {currentYear}</Box>
    </Box>
  );
}

export default Footer;
